/**
 * Airlines by IATA code: [code, name, country, has a logo in /airlines/<code>.png].
 * Carried over from v1 (js/airlines.js and icons/airlines).
 */
export const AIRLINES: readonly (readonly [string, string, string, boolean])[] = [
  ['TK', 'Türk Hava Yolları', 'TR', true],
  ['PC', 'Pegasus', 'TR', true],
  ['XQ', 'SunExpress', 'TR', true],
  ['VF', 'AJet', 'TR', true],
  ['KK', 'AtlasGlobal', 'TR', true],
  ['8Q', 'Onur Air', 'TR', true],
  ['XC', 'Corendon Airlines', 'TR', true],
  ['TB', 'TUI fly Belgium', 'BE', true],
  ['LH', 'Lufthansa', 'DE', true],
  ['UX', 'Air Europa', 'ES', true],
  ['SU', 'Aeroflot', 'RU', true],
  ['A4', 'Azimuth', 'RU', true],
  ['LX', 'SWISS', 'CH', true],
  ['OS', 'Austrian Airlines', 'AT', true],
  ['BA', 'British Airways', 'GB', true],
  ['AF', 'Air France', 'FR', true],
  ['KL', 'KLM', 'NL', true],
  ['IB', 'Iberia', 'ES', true],
  ['AZ', 'ITA Airways', 'IT', true],
  ['SK', 'SAS', 'SE', true],
  ['AY', 'Finnair', 'FI', true],
  ['TP', 'TAP Portugal', 'PT', true],
  ['SN', 'Brussels Airlines', 'BE', true],
  ['LO', 'LOT Polish', 'PL', true],
  ['OK', 'Czech Airlines', 'CZ', true],
  ['RO', 'TAROM', 'RO', true],
  ['FB', 'Bulgaria Air', 'BG', true],
  ['JU', 'Air Serbia', 'RS', true],
  ['OU', 'Croatia Airlines', 'HR', true],
  ['A3', 'Aegean Airlines', 'GR', true],
  ['EI', 'Aer Lingus', 'IE', true],
  ['DY', 'Norwegian', 'NO', true],
  ['W6', 'Wizz Air', 'HU', true],
  ['FR', 'Ryanair', 'IE', true],
  ['U2', 'easyJet', 'GB', true],
  ['VY', 'Vueling', 'ES', true],
  ['DE', 'Condor', 'DE', true],
  ['X3', 'TUI fly DE', 'DE', true],
  ['LS', 'Jet2', 'GB', true],
  ['HV', 'Transavia', 'NL', true],
  ['V7', 'Volotea', 'ES', true],
  ['TO', 'Transavia France', 'FR', true],
  ['EK', 'Emirates', 'AE', true],
  ['QR', 'Qatar Airways', 'QA', true],
  ['EY', 'Etihad', 'AE', true],
  ['TG', 'Thai Airways', 'TH', true],
  ['SV', 'Saudia', 'SA', true],
  ['RJ', 'Royal Jordanian', 'JO', true],
  ['ME', 'MEA', 'LB', true],
  ['GF', 'Gulf Air', 'BH', true],
  ['KU', 'Kuwait Airways', 'KW', true],
  ['WY', 'Oman Air', 'OM', true],
  ['FZ', 'flydubai', 'AE', true],
  ['G9', 'Air Arabia', 'AE', true],
  ['XY', 'flynas', 'SA', true],
  ['J9', 'Jazeera Airways', 'KW', true],
  ['IA', 'Iraqi Airways', 'IQ', true],
  ['IR', 'Iran Air', 'IR', true],
  ['W5', 'Mahan Air', 'IR', true],
  ['QB', 'Qeshm Air', 'IR', true],
  ['J2', 'Azerbaijan Airlines', 'AZ', true],
  ['A9', 'Georgian Airways', 'GE', true],
  ['KC', 'Air Astana', 'KZ', true],
  ['DV', 'SCAT Airlines', 'KZ', true],
  ['HY', 'Uzbekistan Airways', 'UZ', true],
  ['YK', 'Avia Traffic Company', 'KG', true],
  ['T5', 'Turkmenistan Airlines', 'TM', true],
  ['ET', 'Ethiopian Airlines', 'ET', true],
  ['MS', 'EgyptAir', 'EG', true],
  ['AT', 'Royal Air Maroc', 'MA', true],
  ['AH', 'Air Algérie', 'DZ', true],
  ['TU', 'Tunisair', 'TN', true],
  ['SA', 'South African Airways', 'ZA', true],
  ['KQ', 'Kenya Airways', 'KE', true],
  ['AA', 'American Airlines', 'US', true],
  ['DL', 'Delta', 'US', true],
  ['UA', 'United Airlines', 'US', true],
  ['WN', 'Southwest', 'US', true],
  ['B6', 'JetBlue', 'US', true],
  ['AS', 'Alaska Airlines', 'US', true],
  ['AC', 'Air Canada', 'CA', true],
  ['AM', 'Aeromexico', 'MX', true],
  ['LA', 'LATAM', 'CL', true],
  ['AV', 'Avianca', 'CO', true],
  ['CM', 'Copa Airlines', 'PA', true],
  ['SQ', 'Singapore Airlines', 'SG', true],
  ['CX', 'Cathay Pacific', 'HK', true],
  ['NH', 'ANA', 'JP', true],
  ['JL', 'Japan Airlines', 'JP', true],
  ['KE', 'Korean Air', 'KR', true],
  ['OZ', 'Asiana', 'KR', true],
  ['CI', 'China Airlines', 'TW', true],
  ['BR', 'EVA Air', 'TW', true],
  ['CA', 'Air China', 'CN', true],
  ['MU', 'China Eastern', 'CN', true],
  ['CZ', 'China Southern', 'CN', true],
  ['MH', 'Malaysia Airlines', 'MY', true],
  ['AK', 'AirAsia', 'MY', true],
  ['GA', 'Garuda Indonesia', 'ID', true],
  ['PR', 'Philippine Airlines', 'PH', true],
  ['VN', 'Vietnam Airlines', 'VN', true],
  ['AI', 'Air India', 'IN', true],
  ['QF', 'Qantas', 'AU', true],
  ['NZ', 'Air New Zealand', 'NZ', true],
];
